export interface TransformationRow {
  n: string;
  title: string;
  before: string;
  after: string;
}

export const transformationRows: TransformationRow[] = [
  {
    n: '1/4',
    title: 'Planificación',
    before: 'Noches de domingo buscando ejercicios sueltos en YouTube que no terminan de encajar con tu categoría ni con tu pista.',
    after: '−90% tiempo. Sesiones listas en tu móvil en solo 2 clics.'
  },
  {
    n: '2/4',
    title: 'Seguridad',
    before: 'Inseguridad al llegar a la pista sin saber si lo que has preparado es lo correcto para el nivel de tus jugadores. Improviso sobre la marcha.',
    after: 'Confianza total. Ejercicios con correcciones clave, variantes y progresiones claras semana a semana. K1 y K2 organizados.'
  },
  {
    n: '3/4',
    title: 'Variedad',
    before: 'Los mismos 8 ejercicios de siempre que tus jugadores ya hacen en piloto automático (toques contra pared, recepciones básicas).',
    after: '+100% originalidad. Sesiones con condiciones que motivan, desafían y generan aprendizaje real. Dedos, antebrazo, remate, bloqueo, defensa.'
  },
  {
    n: '4/4',
    title: 'Energía',
    before: 'Llegas a la pista mentalmente agotado de haber organizado todo desde cero mientras intentabas cenar.',
    after: 'Cero estrés. Llegas con energía para conectar con tus jugadores desde el primer pitido.'
  }
];

export interface TransformationFooterStat {
  value: string;
  label: string;
}

export const transformationFooterStats: TransformationFooterStat[] = [
  { value: '+120h', label: 'Ahorradas al año' },
  { value: '2 clics', label: 'Para cada sesión lista' },
  { value: '100%', label: 'Profesional' }
];
